module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvaWNvbl93aGl0ZS5mOTMyZTIwYS5wbmciOw=="